<template>
    <form>
        <h2 class="h6" v-text="'Powiadomienia e-mail o promocjach'" />
        <p class="text-sm mb-0">
            Dla każdego ze swoich sklepów wskaż odbiorców, którzy będą
            otrzymywali powiadomienia mailowe o rozpoczynających się oraz
            kończących promocjach. Możesz również zarządzić wysyłką kopii tych
            powiadomień na swój adres mailowy.
        </p>

        <accordion
            v-for="merchant in merchantRecipients"
            class="mt-3"
            :key="merchant.id"
            :is-active="expandedId === merchant.id"
            @header-click="
                expandedId = expandedId === merchant.id ? -1 : merchant.id
            "
        >
            <template #header>
                <div style="white-space: normal; text-align: left;">
                    {{ merchant.name }},
                    {{ $store.getters.getShopAddress(merchant) }}
                </div>
            </template>

            <template #body>
                <ui-checkbox-input
                    v-if="$store.getters.isMainUser"
                    class="text-primary text-sm mb-3"
                    :name="`row-${merchant.id}`"
                    :value="isMainUser(merchant.id)"
                    :disabled="mainUserLoader"
                    label="Wyślij powiadomienie na adres użytkownika głównego"
                    @change="
                        onChangeMainUser({
                            merchant,
                            value: $event
                        })
                    "
                />

                <recipient-email
                    v-for="(recipient, rIdx) in merchant.recipients"
                    class="mb-3"
                    :key="`recipient-${recipient.id}`"
                    :idx="rIdx"
                    :merchant="merchant"
                    :recipient="recipient"
                    :initial-state="initialState"
                    :fetch-recipients="fetchRecipients"
                />

                <recipient-email
                    v-if="newRecipientMerchantId === merchant.id"
                    class="mb-3"
                    :merchant="merchant"
                    :recipient="{ email: '', merchant_id: merchant.id }"
                    :initial-state="initialState"
                    :fetch-recipients="fetchRecipients"
                    @clear-new-recipient="newRecipientMerchantId = null"
                />

                <the-btn
                    @click.stop.prevent.native="
                        newRecipientMerchantId = merchant.id
                    "
                    class="btn btn-secondary mr-auto"
                    :disabled="newRecipientMerchantId === merchant.id"
                >
                    Dodaj odbiorcę
                </the-btn>
            </template>
        </accordion>
    </form>
</template>

<script>
import cloneDumb from '@/helpers/cloneDumb'
import RecipientEmail from './RecipientEmail.vue'

export default {
    name: 'RecipientsEmail',

    components: {
        RecipientEmail
    },

    data() {
        return {
            expandedId: -1,
            newRecipientMerchantId: null,
            mainUserLoader: false,
            initialState: null
        }
    },

    computed: {
        merchants() {
            return this.$store.getters.getAvailableMerchants
        },

        recipients() {
            return this.$store.getters.getMailRecipients
        },

        userEmail() {
            return this.$store.getters.getUser.email
        },

        merchantRecipients() {
            const recipients = this.merchants.map(el => {
                // Filtrowanie recipients według merchant_id
                const merchantRecipients = this.recipients.filter(recipient => {
                    return recipient.merchant_id === el.id
                })

                // Reorganizacja merchantRecipients aby recipient z this.userEmail był pierwszy
                merchantRecipients.sort((a, b) => {
                    if (a.email === this.userEmail) return -1
                    if (b.email === this.userEmail) return 1
                    return 0
                })

                return {
                    ...el,
                    recipients: merchantRecipients
                }
            })

            return recipients
        }
    },

    methods: {
        isMainUser(merchantId) {
            return this.merchantRecipients
                .find(merchant => merchant.id === merchantId)
                .recipients.some(
                    recipient => recipient.email === this.userEmail
                )
        },

        async onChangeMainUser({ merchant, value }) {
            this.mainUserLoader = true

            if (value) {
                const res = await this.$store.dispatch('saveMailRecipient', {
                    merchant_id: merchant.id,
                    email: this.userEmail
                })

                await this.fetchRecipients()

                if (res.data?.message === 'OK') {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content:
                            'Pomyślnie dodano odbiorcę do powiadomień e-mail o promocjach'
                    })
                } else {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                }
            } else {
                const id = merchant.recipients.find(
                    recipient => recipient.email === this.userEmail
                ).id

                const res = await this.$store.dispatch('deleteMailRecipient', {
                    id
                })

                await this.fetchRecipients()

                if (res.data?.message === 'OK') {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content:
                            'Pomyślnie usunięto odbiorcę z listy e-mail o promocjach'
                    })
                } else {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                }
            }

            this.mainUserLoader = false
        },

        async fetchRecipients() {
            await this.$store.dispatch('loadMailRecipients')
            this.initialState = cloneDumb(this.merchantRecipients)
        }
    },

    created() {
        this.fetchRecipients()
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.single-recipient {
    @include media-breakpoint-down(sm) {
        padding: 0.5rem;
    }

    .form-group {
        margin-bottom: 0;
    }
    .name-input {
        @include media-breakpoint-down(sm) {
            margin-top: 10px;
        }
    }
}
</style>
